module.exports = __webpack_public_path__ + "img/1.ebf054b6.png";